import React from 'react';
import { LazyImage } from 'shared/components/LazyImage';
import { PROMO_FEATURES } from './constants';
import * as styles from './styles.css';
import { useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';

export const PromoFeatures: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      {PROMO_FEATURES.map(({ id, title, description, image }) => (
        <div key={id} className={styles['item']}>
          <div className={styles['title']}>{title}</div>
          <div className={styles['description']}>{description}</div>
          <LazyImage src={image} alt={title} className={styles['image']} wrapperClassName={styles['image-wrapper']} />
        </div>
      ))}
    </div>
  );
};
